/**
 * Dump 100 devinettes générées dans un fichier .txt téléchargeable.
 *
 * Usage console : dumpDevinettes() ou dumpDevinettes(200)
 */

import { generateExercice } from '../index';

export const dumpDevinettes = (iterations = 100) => {
    const lines = [];
    for (let i = 0; i < iterations; i++) {
        const p = generateExercice(596, 'devinette_qcm_unique');
        const plain = (p.texte || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
        const clues = plain.match(/Mon chiffre.*?(?= Qui suis-je| Quel)/)?.[0] || plain;
        // bonne_reponse est une lettre → trouver la valeur dans choix
        const br = p.contenu.bonne_reponse;
        let answer;
        if (typeof br === 'string' && br.length === 1) {
            const idx = br.charCodeAt(0) - 65;
            answer = p.contenu.choix[idx];
        } else {
            answer = br;
        }
        lines.push(`${String(i + 1).padStart(3, ' ')}. [${answer}] ${clues}`);
    }
    const txt = lines.join('\n');
    // Télécharger comme fichier
    const blob = new Blob([txt], { type: 'text/plain;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `devinettes_${iterations}.txt`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    console.log(`✅ ${iterations} devinettes dumpées dans devinettes_${iterations}.txt`);
};

if (typeof window !== 'undefined') {
    window.dumpDevinettes = dumpDevinettes;
}
